// SPDX-License-Identifier: GPL-2.0-or-later
// Traduções do Outgun (en, pt-BR; fi e it saíram na v2, OG-384) com a mesma semântica do original: a chave é o texto em
// inglês e `$1..$5` são substituídos pelos argumentos (`_()` em src/language.cpp).
import { CATALOGS } from './catalogs.generated.js';
import { WEB_TEXTS } from './web-texts.js';
export { convertLanguage, phrases, textLines } from './convert.js';
export { WEB_TEXTS } from './web-texts.js';
/** Idiomas do jogo: os do original menos finlandês e italiano (OG-384, D-76). */
export const LOCALES = ['en', 'pt-BR'];
export function catalog(locale) {
    return CATALOGS[locale];
}
/**
 * `_()` do original: traduz o texto em inglês (ou o mantém) e troca `$1..$5` pelos argumentos;
 * um `$n` sem argumento vira texto vazio, como no original.
 */
export function translate(locale, text, ...args) {
    const translated = CATALOGS[locale].texts[text] ?? WEB_TEXTS[locale]?.[text] ?? text;
    let out = '';
    for (let i = 0; i < translated.length; i++) {
        const ch = translated[i];
        const digit = translated.charCodeAt(i + 1) - 48;
        if (ch === '$' && i + 1 < translated.length && digit >= 1 && digit <= 5) {
            out += args[digit - 1] ?? '';
            i++;
        }
        else
            out += ch;
    }
    return out;
}
/** Idioma preferido a partir de `navigator.languages`; inglês se nenhum for suportado. */
export function detectLocale(languages) {
    for (const tag of languages) {
        const lang = tag.toLowerCase();
        if (lang.startsWith('pt'))
            return 'pt-BR';
        if (lang.startsWith('en'))
            return 'en';
    }
    return 'en';
}
/** As fontes do jogo só têm glifos Latin-1 (OG-013): textos fora disso aparecem como "?". */
export function isLatin1(text) {
    for (let i = 0; i < text.length; i++)
        if (text.charCodeAt(i) > 0xff)
            return false;
    return true;
}
//# sourceMappingURL=index.js.map